import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { OutlineButton } from '../../_core/_ui/buttons.component';

interface IPreviewDialogProps {
  open: boolean;
  onClose: () => void;
  // The container-built preview panel (recipient picker + email/SMS surfaces).
  children: React.ReactNode;
}

// 95% page width: maxWidth={false} unlocks MUI's breakpoint cap; zero horizontal
// margin lets the container center the 5% remainder without overflow.
const paperStyle: React.CSSProperties = { width: '95%', maxWidth: '95%', margin: '32px 0' };

export const PreviewDialog: React.FC<IPreviewDialogProps> = ({ open, onClose, children }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth={false}
    PaperProps={{ style: paperStyle }}
    aria-labelledby="compose-preview-title"
  >
    <DialogTitle id="compose-preview-title">Preview</DialogTitle>
    <DialogContent>{children}</DialogContent>
    <DialogActions>
      <OutlineButton onClick={onClose}>Close</OutlineButton>
    </DialogActions>
  </Dialog>
);
